import React, { Component } from 'react';
import { connect } from 'react-redux';

import { getPermissions, getCompany, getSubcompany } from 'auth/selectors';
import * as CostCenters from 'cost_centers/components';

class CostCentersRowContainer extends Component {
  render = () => (
    <CostCenters.Row
      handleToggle={this.props.handleToggle} /////////////
      costCenter={this.props.costCenter}
      company={this.props.company}
      subcompany={this.props.subcompany}
      permissions={this.props.permissions}
    />
  );
}

const mapStateToProps = (state) => ({
  permissions: getPermissions(state),
  company: getCompany(state),
  subcompany: getSubcompany(state),
});

export default connect(mapStateToProps, null)(CostCentersRowContainer);



// WEBPACK FOOTER //
// src/modules/secured/modules/cost_centers/containers/CostCenterRowContainer.js